<template>
	<div class="container">
		<div class="main_box">
			<!--联系我们-->
			<fixed></fixed>
			<!--联系我们-->
			<!--导航-->
			<navbar></navbar>
			<!--导航-->
			<!--banner-->
			<div v-if="infoData" class="banner_box"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<img src="../../assets/img/News.webp" class="bg" />
				<div class="msg_box">
					<div class="tit">{{ infoData.title }}</div>
					<!-- <div class="txt">
						CorDx ensures a reliable supply of accurate, easy-to-use diagnostics products priced for all.
					</div> -->
				</div>
			</div>
			<!--banner-->
			<!--正文-->
			<div v-if="infoData" class="block_main"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="top_box">
					<div class="left">{{ infoData.fabu_time }}</div>
					<div class="right">
						<!-- <img :src="isOne ? require('@/assets/img/路径 429@2x_副本.png') : require('@/assets/img/路径 429@2x.png')" @mouseover="isOne = true" @mouseleave="isOne = false" @click="share1" /> -->
						<img style="width: 28px;position: relative;top: 0px;" :src="isTwo ? require('@/assets/img/路径 1@2x_副本2.png') : require('@/assets/img/路径 1@2x_副本.png')" @mouseover="isTwo = true" @mouseleave="isTwo = false" @click="share2" />
						<img :src="isThree ? require('@/assets/img/路径 430@2x_副本.png') : require('@/assets/img/路径 430@2x.png')" @mouseover="isThree = true" @mouseleave="isThree = false" @click="share3" />
					</div>
				</div>
				<!-- <div class="img_box">
					<img :src="infoData.url" />
				</div> -->
				<div class="content" v-html="infoData.content"></div>
			</div>
			<!--正文-->
			<!--表单-->
			<div class="form_box">
				<div class="title">Healthcare providers, receive 20% off your first order.</div>
				<div class="iframe_box">
					<iframe
						:src="formUrl"
						width="100%"
						height="420px"
						frameborder="0"
						allowfullscreen
					>
					</iframe>
				</div>
			</div>
			<!--表单-->
			<!--版权-->
			<footerBox></footerBox>
			<!--版权-->
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navbar from '@/component/pc/nav.vue'  //导航组件
import footerBox from '@/component/pc/footer.vue'  //版权组件
import fixed from '@/component/pc/fixed.vue'  //联系我们悬浮
import { resourcesInfo } from '@/api/public';
export default {
	components:{
		navbar,
		footerBox,
		fixed,
	},
	metaInfo() {
		return {
			meta: [
				{
					name: "description",
					content: this.metaDescription,
				},{
					name: "keywords",
					content: this.metaKeywords,
				}
			]
		}
	},
	data() {
		return {
			isLoading: true,  //界面loading
			isOne: false,
			isTwo: false,
			isThree: false,
			infoData: null,
			metaDescription: '',
			metaKeywords: '',
			formUrl: 'https://cordx.com/hbspt-form2.html?t='+new Date().getTime()
		}
	},
	created(){
		let that = this;
		window.scroll(0, 0);
		//请求文章详情
		resourcesInfo({
			custom: that.$route.params.resourcesInfoId,
		}).then(res => {
			document.title = res.data.title + ' - CorDx';
			that.metaDescription = res.data.description;
			that.metaKeywords = res.data.keywords;
			that.infoData = res.data;
			//设置OG标签
			that.setOgTag('og:locale', 'en_US');
			that.setOgTag('og:title', res.data.title);
			that.setOgTag('og:description', res.data.description);
			that.setOgTag('og:image', res.data.url);
			that.setOgTag('og:image:width', '1200');
			that.setOgTag('og:image:height', '630');
			that.setOgTag('og:image:type', 'webp');
			that.isLoading = false;
		});
	},
	mounted() {
		let that = this;
	},
	watch: {
		//
	},
	methods: {
		//设置OG标签
		setOgTag(property, content) {
			const meta = document.querySelector(`meta[property='${property}']`);
			if(meta) {
				meta.setAttribute('content', content);
			} else {
				const newMeta = document.createElement('meta');
				newMeta.setAttribute('property', property);
				newMeta.setAttribute('content', content);
				document.head.appendChild(newMeta);
			}
		},
		//分享
		share1() {
			let that = this;
			// window.open("https://www.facebook.com/login.php?skip_api_login=1&api_key=966242223397117&signed_next=1&next=https%3A%2F%2Fwww.facebook.com%2Fsharer.php%3Fu%3D"+window.location.href+"&cancel_url=https%3A%2F%2Fwww.facebook.com%2Fdialog%2Fclose_window%2F%3Fapp_id%3D966242223397117%26connect%3D0%23_%3D_&display=popup&locale=zh_CN", 'yt', 'height=600,width=800');
		},
		share2() {
			let that = this;
			// let url = 'https://twitter.com/cordx_us';
			// let text = encodeURIComponent(that.infoData.title);
			// let via = encodeURIComponent('CorDx');
			// let hashtags = encodeURIComponent(that.infoData.keywords);
			// window.open('https://twitter.com/intent/tweet?url=' + encodeURIComponent(url) + '&text=' + text + '&via=' + via + '&hashtags=' + hashtags, "_blank");
			window.open('https://twitter.com/cordx_us', '_blank');
		},
		share3() {
			let that = this;
			// let url = encodeURIComponent('https://www.linkedin.com/company/cordx');
			// let title = encodeURIComponent(that.infoData.title);
			// let summary = encodeURIComponent(that.infoData.keywords);
			// window.open('https://www.linkedin.com/shareArticle?mini=true&url=' + url + '&title=' + title + '&summary=' + summary, '_blank');
			window.open('https://www.linkedin.com/company/cordx', '_blank');
		},
	}
}
</script>

<style scoped>
>>> .content ol,>>> .content ul{
	list-style: initial !important;
	margin: revert !important;
	padding: revert !important;
}
/* >>> .content h3 strong{
	font-size: 24px;
}
>>> .content h3 font{
	font-size: 24px;
}
>>> .content h5{
	font-size: 20px;
}
>>> .content h5 font{
	font-size: 20px;
}
>>> .content p{
	font-size: 18px;
}
>>> .content p font{
	font-size: 18px;
}
>>> .content li{
	font-size: 18px;
}
>>> .content li::before{
	content: '●';
	padding-right: 4px;
} */
</style>
<style lang="less" scoped>
.main_box{
	width: 100%;
	height: auto;
	.form_box{
		.iframe_box{
			width: 1140px;
			margin: 30px auto 0 auto;
		}
		.title{
			padding: 30px;
			text-align: center;
			font-size: 20px;
			color: #ffffff;
			background-color: #0B318F;
		}
	}
	/*正文*/
	.block_main{
		width: 1140px;
		margin: 0 auto;
		padding: 100px 0;
		.img_box{
			width: 100%;
			padding: 10px 0 30px 0;
			img{ width: 100%; }
		}
		.top_box{
			display: flex;
			padding-bottom: 30px;
			.left{
				flex: 1;
				font-size: 18px;
				color: #706B69;
			}
			.right{
				flex: 1;
				text-align: right;
				img{
					width: 25px;
					margin-left: 30px;
					cursor: pointer;
				}
			}
		}
	}
	/*banner*/
	.banner_box{
		width: 100%;
		position: relative;
		margin-bottom: 20px;
		.bg{
			width: 100%;
		}
		.msg_box{
			width: 1140px;
			margin: 0 auto;
			color: #000000;
			text-align: center;
			.txt{
				padding-top: 10px;
				font-size: 26px;
			}
			.tit{
				font-size: 50px;
			}
		}
	}
}
</style>
